/** @format */

import { TStore } from '@/redux/helpers/createStore';
import { caseUnsensitiveEquals } from '@/utils/helpers/caseUnsensitiveEquals';

export const selectorAvailabilityArray = (store: TStore) => store.shared.availabilityArray;

export const selectorAvailabilityRoom = (store: TStore, roomCode: string) => {
  const availabilityArray = store.shared.availabilityArray;
  return availabilityArray.find(availability => availability && caseUnsensitiveEquals(availability.bedCode, roomCode));
};
